var _defs, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCJprofile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CJ_profile",
    "data-name": "CJ profile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 917 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #682e39;\n      }\n\n      .cls-3 {\n        fill: #2d0810;\n      }\n\n      .cls-4 {\n        fill: #06b6db;\n      }\n\n      .cls-5 {\n        fill: #000708;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-7 {\n        fill: #e0a35a;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 462.17,
    cy: 499.83,
    r: 447.5
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 462.17,
    cy: 499.83,
    r: 447.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 287.67,
    y: 344.33,
    width: 370,
    height: 538
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.81,903.99s6.28-280.68,200.86-281.65c199-1,190.76,278.3,190.76,278.3l-198.76,91.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M669.67,392.33c-7.84-5.15-12.25-2.74-18,3-2.54-104.97-83.71-196.1-183.76-196.1s-178.2,86.83-178.24,194.1c-3.09-.64-12.06-.17-15.09,1.7-16.29,10.02-13.66,39.85,.62,55.77,7.07,7.88,37.56,8.58,40.36,17.43,17.11,54.1,53.11,111.1,111.17,128.36l-5.58,67.2s11.69,15.58,49.67,16.56c37.98,.97,49.67-19.48,49.67-19.48l-5.83-65.53c59-18,104-69,111-125,7.91-4.34,36.62-25.76,45.54-35.12,13.8-14.48,13.41-33.05-1.54-42.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 648.17,
    cy: 460.83,
    r: 9.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 271.44,
    cy: 435.94,
    r: 3.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 271.17,
    cy: 407.37,
    rx: 4.5,
    ry: 4.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 297.49,
    cy: 464.97,
    r: 9.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 536.23,
    cy: 424.3,
    rx: 26.29,
    ry: 16.66,
    transform: "translate(-55.95 766.2) rotate(-68.35)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 416.04,
    cy: 424.3,
    rx: 16.66,
    ry: 26.29,
    transform: "translate(-127.18 183.39) rotate(-21.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M655.26,325.25c-23.99-82.66-103.61-121.85-167.5-126.43-81.22-5.82-177.64,41.1-199.3,132.73-16.77,70.93,15.21,142.79,65.21,197.79,0,0,3.15-72.39,5.53-137.15,.23-6.23,1.01-41.95,5.12-49.81,10.66,22.61,23.37,40.19,23.37,40.19-.14,3.73,184.1-.3,184.1-.3,0,0,7.1-12.38,14.18-35.11,1.45,3.37,7.68,30.35,10.04,38.6,8.69,53.84-1.33,140.59-1.33,140.59,51-56,81.49-129.06,60.59-201.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "461.67 753.33 410.45 726.94 354.67 717.33 373.93 653.95 422.62 622.34 425.14 680.34 461.67 753.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "480.67 753.33 531.88 726.94 587.67 717.33 568.41 653.95 519.72 622.34 517.19 680.34 480.67 753.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 512.67,
    y: 777.33,
    width: 67,
    height: 14
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCJprofile);
export default __webpack_public_path__ + "static/media/CJ profile.7605281880a2b82b580f53a07f26776d.svg";
export { ForwardRef as ReactComponent };